import { service } from '@/ajax/request'
export const getHourList = () => (
    service({
        url: `/ws-twelve-hour-manage/list`,
        method: 'POST',
    })
)

export const getHourDetailById = (params: any) => (
    service({
        url: `/ws-twelve-hour-manage/get-one`,
        method: 'POST',
        params,
    })
)

export const editHourDetail = (params: any) => (
    service({
        url: `/ws-twelve-hour-manage/create-or-update`,
        method: 'POST',
        params
    })
)